const fireCenteredSystem = {
  emitters: [
    {
      id: 1,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0.15, 0.5],
          [0.98, 0.5],
        ],
      },
      angle: {
        type: 'range',
        value: [1, 2],
      },
      speed: {
        type: 'range',
        value: [0.4, 1],
      },
      rate: {
        type: 'float',
        value: 1,
      },
      particle: {
        lifetime: {
          type: 'range',
          value: [0.2, 1],
        },
        shape: {
          type: 'string',
          value: 'flame',
        },
        rotation: {
          type: 'range',
          value: [2.94, 3.34],
        },

        gravity: {
          type: 'float',
          value: 0.001,
        },
        wobble: {
          type: 'float',
          value: 0,
        },
        scale: {
          type: 'range',
          value: [4, 10],
        },
        scaleRate: {
          type: 'range',
          value: [0.05, 0.1],
        },
        drag: {
          type: 'vector',
          value: [1, 1],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          color: '#fff102',
          value: [
            {
              keyframe: 0,
              value: [238, 199, 22, 0.9],
            },
            {
              keyframe: 80,
              value: [243, 31, 31, 0.9],
            },

            {
              keyframe: 100,
              value: [243, 31, 31, 0],
            },
          ],
        },
      },
    },
    {
      id: 2,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0.15, 0.5],
          [0.98, 0.5],
        ],
      },
      angle: {
        type: 'range',
        value: [-1, -2],
      },
      speed: {
        type: 'range',
        value: [0.4, 1],
      },
      rate: {
        type: 'float',
        value: 1,
      },
      particle: {
        lifetime: {
          type: 'range',
          value: [0.2, 1],
        },
        shape: {
          type: 'string',
          value: 'flame',
        },
        rotation: {
          type: 'range',
          value: [-0.2, 0.2],
        },

        gravity: {
          type: 'float',
          value: 0.001,
        },
        wobble: {
          type: 'float',
          value: 0,
        },
        scale: {
          type: 'range',
          value: [4, 10],
        },
        scaleRate: {
          type: 'range',
          value: [0.05, 0.1],
        },
        drag: {
          type: 'vector',
          value: [1, 1],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          color: '#fff102',
          value: [
            {
              keyframe: 0,
              value: [238, 199, 22, 0.9],
            },
            {
              keyframe: 80,
              value: [243, 31, 31, 0.9],
            },

            {
              keyframe: 100,
              value: [243, 31, 31, 0],
            },
          ],
        },
      },
    },
    {
      id: 1,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0.15, 0.5],
          [0.98, 0.5],
        ],
      },
      angle: {
        type: 'range',
        value: [1, 2],
      },
      speed: {
        type: 'range',
        value: [0.4, 1],
      },
      rate: {
        type: 'float',
        value: 11,
      },
      particle: {
        lifetime: {
          type: 'range',
          value: [0.4, 1],
        },
        shape: {
          type: 'string',
          value: 'circle',
        },
        rotation: {
          type: 'range',
          value: [0, 6.28],
        },

        gravity: {
          type: 'float',
          value: 0.001,
        },
        wobble: {
          type: 'float',
          value: 5,
        },
        scale: {
          type: 'range',
          value: [0.1, 1],
        },
        scaleRate: {
          type: 'range',
          value: [0.1, 0.2],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          color: '#fff102',
          value: [
            {
              keyframe: 0,
              value: [238, 199, 22, 0.9],
            },
            {
              keyframe: 50,
              value: [243, 31, 31, 0.9],
            },
            {
              keyframe: 100,
              value: [0, 0, 0, 0],
            },
          ],
        },
      },
    },
    {
      id: 4,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0.15, 0.5],
          [0.98, 0.5],
        ],
      },
      angle: {
        type: 'range',
        value: [-1, -2],
      },
      speed: {
        type: 'range',
        value: [0.4, 1],
      },
      rate: {
        type: 'float',
        value: 11,
      },
      particle: {
        lifetime: {
          type: 'range',
          value: [0.4, 1],
        },
        shape: {
          type: 'string',
          value: 'circle',
        },
        rotation: {
          type: 'range',
          value: [0, 6.28],
        },

        gravity: {
          type: 'float',
          value: 0.001,
        },
        wobble: {
          type: 'float',
          value: 5,
        },
        scale: {
          type: 'range',
          value: [0.1, 1],
        },
        scaleRate: {
          type: 'range',
          value: [0.1, 0.2],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          color: '#fff102',
          value: [
            {
              keyframe: 0,
              value: [238, 199, 22, 0.9],
            },
            {
              keyframe: 50,
              value: [243, 31, 31, 0.9],
            },
            {
              keyframe: 100,
              value: [0, 0, 0, 0],
            },
          ],
        },
      },
    },
    {
      id: 5,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0.15, 0.5],
          [0.98, 0.5],
        ],
      },
      angle: {
        type: 'range',
        value: [-1, -2],
      },
      speed: {
        type: 'range',
        value: [1.25, 2.5],
      },
      rate: {
        type: 'float',
        value: 15,
      },
      particle: {
        lifetime: {
          type: 'range',
          value: [1.4, 2.2],
        },
        shape: {
          type: 'string',
          value: 'square',
        },
        rotation: {
          type: 'range',
          value: [0, 6.28],
        },

        gravity: {
          type: 'float',
          value: -0.004,
        },
        drag: {
          type: 'vector',
          value: [2.5, 2.5],
        },
        scale: {
          type: 'range',
          value: [0.5, 1],
        },

        color: {
          type: 'colorOverLife',
          color: '#fff102',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 0, 0.9],
            },
            {
              keyframe: 80,
              value: [255, 255, 0, 0.9],
            },
            {
              keyframe: 100,
              value: [0, 0, 0, 0],
            },
          ],
        },
      },
    },
    {
      id: 6,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0.15, 0.5],
          [0.98, 0.5],
        ],
      },
      angle: {
        type: 'range',
        value: [1, 2],
      },
      speed: {
        type: 'range',
        value: [1.25, 2.5],
      },
      rate: {
        type: 'float',
        value: 15,
      },
      particle: {
        lifetime: {
          type: 'range',
          value: [1.4, 2.2],
        },
        shape: {
          type: 'string',
          value: 'square',
        },
        rotation: {
          type: 'range',
          value: [0, 6.28],
        },

        gravity: {
          type: 'float',
          value: 0.004,
        },
        drag: {
          type: 'vector',
          value: [2.5, 2.5],
        },
        scale: {
          type: 'range',
          value: [0.5, 1],
        },

        color: {
          type: 'colorOverLife',
          color: '#fff102',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 0, 0.9],
            },
            {
              keyframe: 80,
              value: [255, 255, 0, 0.9],
            },
            {
              keyframe: 100,
              value: [0, 0, 0, 0],
            },
          ],
        },
      },
    },
    {
      id: 10,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0, 0.2],
          [1.2, 1.2],
        ],
      },
      angle: {
        type: 'float',
        value: -3.14,
      },
      speed: {
        type: 'float',
        value: 0.1,
      },
      rate: {
        type: 'float',
        value: 11,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 6,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0.0005,
        },
        scale: {
          type: 'range',
          value: [20, 200],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          value: [
            {
              keyframe: 0,
              value: [0, 0, 0, 0],
            },
            {
              keyframe: 20,
              value: [0, 0, 0, 0.004],
            },
            {
              keyframe: 40,
              value: [0, 0, 0, 0.004],
            },
            {
              keyframe: 100,
              value: [0, 0, 0, 0],
            },
          ],
        },
      },
    },
  ],
  effects: [
    {
      type: 'time',
      emitters: [1, 2, 3, 4],
      energy: 'above',
      data: {
        amount: 1.5,
      },
    },
    {
      type: 'time',
      emitters: [1, 2, 3, 4],
      energy: 'below',
      data: {
        amount: 0.5,
      },
    },
    {
      type: 'lifetime',
      emitters: [1, 2, 3, 4],
      energy: 'below',
      data: {
        amount: 0.05,
      },
    },
    {
      type: 'lifetime',
      emitters: [1, 2, 3, 4],
      energy: 'above',
      data: {
        amount: 1.4,
      },
    },
    {
      type: 'spawnOffset',
      emitters: [1, 3],
      energy: 'above',
      data: {
        amount: [0, 0.1],
      },
    },
    {
      type: 'spawnOffset',
      emitters: [2, 4],
      energy: 'above',
      data: {
        amount: [0, -0.1],
      },
    },
  ],
}

export default fireCenteredSystem
